<template>
  <div
    class="flex items-center justify-between w-full"
    @mouseover="handleMouseOver"
    @mouseleave="isShowChooseText = false"
  >
    <div :class="['flex items-center', {'disable-text-color': isDisabled}]">
      <span :class="['material-icons mr-2.5', {'disable-icon-color': isDisabled}]">account_circle</span>
      <p class="inline-block" v-html="name" />
      <span class="bullet-color">&nbsp;&bull;&nbsp;</span>
      <p>
        {{ gender }} <span class="bullet-color">&bull;</span> {{ dob }} 
      </p> 
    </div>
    <p class="choose-color mr-3" v-if="isShowChooseText">Choose</p>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ""
    },
    gender: {
      type: String,
      default: "Female"
    },
    dob: {
      type: String,
      default: "MM/DD/YYYY"
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShowChooseText: false
    }
  },
  methods: {
    handleMouseOver() {
      if (!this.isDisabled) {
        this.isShowChooseText = true;
      }
    }
  }
}
</script>

<style scoped>

.bullet-color {
  color: #C9CACD;
}

.choose-color {
  color: #20A7C1;
}

.disable-icon-color {
  color: #979797;
}

.disable-text-color {
  color: #C9CACD;
}

</style>

